import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

const EL_AddDates: React.FC = () => {
  const location = useLocation();
  const [dates, setDates] = useState<string>('');
  const [error, setError] = useState<string>('');

  // Get query parameters
  const searchParams = new URLSearchParams(location.search);
  const installmentDate = searchParams.get('InstallmentDate') || '';
  const interval = searchParams.get('Interval') || '';
  const noOfInstallments = searchParams.get('NoOfInstallments') || '';

  // Load data on mount
  useEffect(() => {
    const fetchDates = async () => {
      if (!installmentDate || !interval || !noOfInstallments) {
        setError('Missing required parameters');
        return;
      }

      try {
        const params = new URLSearchParams({
          InstallmentDate: installmentDate,
          Interval: interval,
          NoOfInstallments: noOfInstallments
        });

        const response = await fetch(`${API_BASE_URL}api/add_dates?${params.toString()}`, {
          credentials: 'include'
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const text = await response.text();
        // Remove the delimiter to get just the dates
        const datesOnly = text.split('----------!#$*()-_+=----------')[0];
        setDates(datesOnly);
      } catch (err) {
        console.error('Error fetching dates:', err);
        setError('Failed to calculate installment dates');
      }
    };

    fetchDates();
  }, [installmentDate, interval, noOfInstallments]);

  // Set page title
  useEffect(() => {
    document.title = "Add Dates";
    return () => {
      document.title = '';
    };
  }, []);

  if (error) {
    return (
      <div style={{ padding: '20px', color: 'red', fontFamily: 'Arial' }}>
        <h2>Error</h2>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div style={{
      fontFamily: 'Arial, sans-serif',
      fontSize: '12pt',
      padding: '20px',
      backgroundColor: 'azure'
    }}>
      <h2>Add Dates</h2>
      {dates && (
        <div style={{ marginTop: '20px' }}>
          <h3>Installment Dates:</h3>
          <p>{dates.split(',').join(', ')}</p>
        </div>
      )}
    </div>
  );
};

export default EL_AddDates;